export const sortCustomAttributes = (customAttributes) => {
    const withEmptyDisplayAfter = customAttributes.filter(({ display_after }) => !display_after);
    if (withEmptyDisplayAfter.length === 0) {
        console.warn("Wrong configuration - cannot sort custom attributes (using default order)");
        return customAttributes;
    }
    const withDisplayAfter = customAttributes.filter(({ display_after }) => display_after);
    const results = [...withEmptyDisplayAfter];
    let iteration = 0;
    while (iteration < withDisplayAfter.length) {
        const index = results.findIndex(({ code }) => code === withDisplayAfter[iteration].display_after);
        if (index >= 0) {
            results.splice(index + 1, 0, withDisplayAfter[iteration]);
            withDisplayAfter.splice(iteration, 1);
            iteration = 0;
        }
        else {
            iteration++;
        }
    }
    if (withDisplayAfter.length) {
        console.warn("Wrong configuration - circular dependency in custom attributes or typo in display_after (using default order)");
        return customAttributes;
    }
    return results;
};
//# sourceMappingURL=sortCustomAttributes.js.map